<script>

export default {
  name: 'ModalTrigger',
  props: {
    url: {
      type: String,
      default: () => null,
    },
    name: {
      type: String,
    },
    classes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openPopup(e) {
      console.log(this.events, this.$listeners, '===events');
      this.$modal.show(this.componentLoader,
        {
          info: this.$attrs,
        }, {
          height: 'auto',
          name: this.name,
          minWidth: 300,
          classes: this.classes.concat(['defaultModal']),
          adaptive: true,
          scrollable: true,
        }, {
          opened: t => this.$emit('opened', t),
          'before-open': t => this.$emit('before-open', t),
          'before-close': t => this.$emit('before-close', t),
          ...this.$listeners,
        })
    },
  },
  computed: {

    componentLoader() {
      console.log("🚀 ~ `@app/${this.url}`:", `@app/${this.url}`)
      return () => import(`@app/${this.url}`)
    },
  },
  render(h) {
    return this.$scopedSlots.default({
      open: e => {
        this.openPopup(e)
      },
    })
  },
}
</script>
